export default __webpack_public_path__ + "static/media/image6.8c3dd3ec.svg";